/**
 * Activate the Elementor tab containing a WooCommerce form error.
 */
(function () {
  function hasErrorMessage(selector) {
    var error = document.querySelector(selector);

    return error && error.textContent.trim().length > 0;
  }

  function renderFailedLoginMessage() {
    var params = new URLSearchParams(window.location.search);
    var loginForm = document.querySelector('#login-form');

    if (
      params.get('login') !== 'failed' ||
      !loginForm ||
      hasErrorMessage('#login-form .woocommerce-error')
    ) {
      return;
    }

    var error = document.createElement('ul');
    var errorItem = document.createElement('li');

    error.className = 'woocommerce-error';
    error.setAttribute('role', 'alert');
    errorItem.textContent = 'Incorrect username or password.';
    error.appendChild(errorItem);

    var loginFormElement = loginForm.querySelector('form');

    if (loginFormElement) {
      loginFormElement.insertAdjacentElement('afterbegin', error);
    } else {
      loginForm.insertAdjacentElement('afterbegin', error);
    }
  }

  function activateErrorTab() {
    renderFailedLoginMessage();

    if (hasErrorMessage('#registration-form .woocommerce-error')) {
      var registerButton = document.querySelector('#register');

      if (registerButton) {
        registerButton.click();
      }

      return;
    }

    if (hasErrorMessage('#login-form .woocommerce-error')) {
      var loginButton = document.querySelector('#login');

      if (loginButton) {
        loginButton.click();
      }
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      window.setTimeout(activateErrorTab, 100);
    });
  } else {
    window.setTimeout(activateErrorTab, 100);
  }
})();
